Ext.define('SA.view.BackNavigationPopup', {
    alias: 'widget.back-navigation-popup',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-back-navigation-popup',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-back-navigation-popup-header',
            itemId: 'header',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-back-navigation-popup-title',
                    html: 'Confirm Navigation'
                }, {
                    xtype: 'close-button',
                    closeAction: 'onStayOnPageRequested'
                }
            ]
        }, {
            xtype: 'component',
            cls: 'sa-back-navigation-popup-body',

            html: [
                '<svg class="sa-back-navigation-popup-warning-svg"><use href="#sa-icon-warning"></use></svg>',
                '<div>',
                    '<strong>You’re about to navigate away from the SimplyAnalytics app.</strong>',
                    '<br><br>Are you sure you wish to do so?',
                '</div>'
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-back-navigation-popup-footer',

            items: [
                {
                    xtype: 'sa-button',
                    cls: 'sa-back-navigation-popup-leave-page-btn',
                    itemId: 'leavePageBtn',
                    text: 'Yes, leave page'
                }, {
                    xtype: 'sa-button',
                    itemId: 'stayOnPageBtn',
                    text: 'No, stay on page',
                    ui: 'primary'
                }
            ]
        }
    ],

    initComponent() {
        this.callParent();

        this.down('#leavePageBtn').on('click', this.onLeavePageRequested, this);
        this.down('#stayOnPageBtn').on('click', this.onStayOnPageRequested, this);
    },

    onLeavePageRequested() {
        this.fireEvent('request:leave');

        this.destroy();
    },

    onStayOnPageRequested() {
        this.fireEvent('request:stay');

        this.destroy();
    }
});